import createVueComponent from '../createVueComponent';

const ListX = createVueComponent('ListXIcon', [
  ['path', { d: 'M11 12H3' }],
  ['path', { d: 'M16 6H3' }],
  ['path', { d: 'M16 18H3' }],
  ['path', { d: 'M19 10l-4 4' }],
  ['path', { d: 'M15 10l4 4' }],
]);

export default ListX;
